import { useAppState } from 'AppContextProvider'
import ReinforcementScreenContainer from 'Components/ReinforcementScreen/ReinforcementMain'
import { FC, useMemo } from 'react'
import { Trans } from 'react-i18next'
import { ReinforcementDescriptionHighlight, ReinforcementTitleHighlight } from '../Typography'
import { ReinforcementScreenBackgrounds, ReinforcementScreenContent } from 'types/reinforcementScreenTypes'
import { images } from 'images'
import { calculateBMI } from 'Lib'

const stepImages: ReinforcementScreenBackgrounds<string> = {
  m: {
    normal: images.BMIInfoMaleNormal,
    overweight: images.BMIInfoMaleOverweight
  },
  f: {
    normal: images.BMIInfoFemaleNormal,
    overweight: images.BMIInfoFemaleOverweight
  }
}

interface BMIInfoScreenProps {
  onContinue: (shouldSkipNext?: boolean) => Promise<void>
}

const BMIInfoScreen: FC<BMIInfoScreenProps> = ({ onContinue }) => {
  const { appState } = useAppState()

  const screenContent = useMemo((): ReinforcementScreenContent => {
    const { gender, weight, height } = appState.selections ?? {}

    if (!weight || !height || !gender) {
      logEvent('web_reinforcement_no_bmi_data')
    }

    const bmi = calculateBMI(height?.inCm?.value ?? 120, weight?.inKg?.value ?? 160)
    const genderKey: IGender = (!gender || gender === 'o') ? 'f' : gender
    const bmiStatus = bmi >= 24.9 ? 'overweight' : 'normal'
    return {
      localePrefix: `reinforcementScreens.bmi_info.${genderKey}.${bmiStatus}`,
      backgroundImagePath: stepImages[genderKey]![bmiStatus]
    }
  }, [appState.selections?.gender, appState.selections?.weight, appState.selections?.height])

  return (
    <ReinforcementScreenContainer
      title={
        <Trans
          i18nKey={`${screenContent.localePrefix}.title`}
          components={{ em: <ReinforcementTitleHighlight /> }}
        />
      }
      description={
        <Trans
          i18nKey={`${screenContent.localePrefix}.body`}
          components={{ em: <ReinforcementDescriptionHighlight /> }}
        />
      }
      backgroundImage={screenContent.backgroundImagePath}
      onContinue={onContinue}
    />
  )
}

export default BMIInfoScreen
